import { useMutation } from "@tanstack/react-query";
import type { CatalogSampleType } from "../../models/CatalogSampleType";
import { upsertCatalogSampleType } from "../../repositories/CatalogSampleTypeRepository";

export const useUpsertCatalogSampleTypeMutation = () => {
  return useMutation({
    mutationFn: async (sampleType: CatalogSampleType) => {
      const resp = await upsertCatalogSampleType(sampleType);
      if (!resp.ok)
        throw new Error(resp.message ?? "Failed to save catalog sample type");
      return resp;
    },
  });
};
